import { ProfileData } from 'store/modules/profile_store/types';
import tabId from './tabId';

const companyId = (profile: ProfileData) => {
  if (profile.representant && profile.currentCompany[tabId()] !== profile.clientId) {
    if (profile.currentCompany[tabId()] === undefined) {
      return profile.clientId;
    }
    return profile.currentCompany[tabId()];
  }
  return profile.clientId;
};

export default companyId;
